import {
    EpgProgram,
    RBChannel,
    RBProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import { convertStringToBoolean } from 'utils/convertStringToBoolean';

function isTimeshiftAvailable(
    channel: RBChannel | undefined,
    asset:
        | EpgProgram
        | RBProgram
        | VodEditorial
        | RecordingMetadata
        | undefined,
) {
    const channelClientTimeshiftControl =
        channel?.editorial.clientTimeshiftControl;
    const assetClientTimeshiftControl = asset?.clientTimeshiftControl;

    if (assetClientTimeshiftControl != null) {
        return convertStringToBoolean(assetClientTimeshiftControl);
    }

    if (channelClientTimeshiftControl != null) {
        return convertStringToBoolean(channelClientTimeshiftControl);
    }

    return false;
}

export default isTimeshiftAvailable;
